module.exports = __webpack_public_path__ + "static/media/Section1_Fingertips.0d66ffe3.svg";